import React from 'react';
import styles from './DefaultPrompts.module.css';
import { IoSparkles } from 'react-icons/io5';

const DEFAULT_PROMPTS = [
  {
    title: 'Interactive Data Visualization 📊',
    text: 'Create a dynamic chart to visualize data trends',
    category: 'visualization'
  },
  {
    title: 'Physics Simulation Lab 🔬',
    text: 'Explore physics concepts with interactive simulations',
    category: 'education'
  },
  {
    title: 'Creative Coding Canvas 🎨',
    text: 'Generate beautiful algorithmic art patterns',
    category: 'art'
  },
  {
    title: 'Math Problem Solver ✏️',
    text: 'Solve and explain mathematical concepts step by step',
    category: 'education'
  }
];

const DefaultPrompts = ({ onPromptSelect, onPromptSubmit, conversationId }) => {
  const handlePromptClick = (promptText) => {
    // First, update the input with the new prompt
    onPromptSelect(promptText);
    // Use a small delay to ensure the input value is updated before submitting
    requestAnimationFrame(() => onPromptSubmit(promptText));
  };

  return (
    <div className={styles.promptsContainer}>
      <h2 className={styles.heading}>
        <IoSparkles size={18} />
        Explore these ideas
      </h2>
      <div className={styles.promptsGrid}>
        {DEFAULT_PROMPTS.map((prompt, index) => (
          <div
            key={`${conversationId || 'new'}-${index}`}
            className={styles.promptCard}
            onClick={() => handlePromptClick(prompt.text)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                handlePromptClick(prompt.text);
              }
            }}
            data-category={prompt.category}
          >
            <h3 className={styles.promptTitle}>{prompt.title}</h3>
            <p className={styles.promptText}>{prompt.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DefaultPrompts;
